/* eslint-disable no-undef */

/* eslint-disable no-unused-vars */
import {citas} from './siteActions/citas'

function checkPagos (lista, checkFunction) {
  for (var row in lista) {
    if (!lista[row].checkPago) {
      lista[row].checkPago = true
      checkFunction(row)
    }
  }
}

export let actions = {
  verFotoMulta (args) {
    $UTIL.loader.show()
    let homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
    if (homeMultasScope == null) {
      window.open('#/inicio-home', '_self')
      homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
      setTimeout(function () {
        checkFotoMulta()
      }, 4000)
    } else {
      checkFotoMulta()
    }
    function checkFotoMulta () {
      if (args.tipo === 'COMPARENDO') homeMultasScope.homeMultasController.checkDetalleFotoMulta(args.index)
      else if (args.tipo === 'MULTA') homeMultasScope.homeMultasController.checkDetalleFotoMultaMoroso(args.index)
      $UTIL.loader.hide()
    }
  },
  licenciaConduccion () {
    window.open('#/inicio/consultar-estado-licencia', '_self')
    document.getElementById('idLicenciasEstadoInput').value = sessionStorage.getItem('nroIdentificacion')
  },
  iniciarPagosMultas () {
    $UTIL.loader.show()
    let homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
    if (homeMultasScope == null) {
      window.open('#/inicio-home', '_self')
      homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
      setTimeout(function () {
        seleccionAllPagos()
      }, 4000)
    } else {
      seleccionAllPagos()
    }
    function seleccionAllPagos () {
      let listComparendos = homeMultasScope.homeMultasController.infoMultas.informacionComparendo
      let listMultas = homeMultasScope.homeMultasController.infoMultas.informacionMulta
      checkPagos(listComparendos, homeMultasScope.homeMultasController.checkPagoComparendo)
      checkPagos(listMultas, homeMultasScope.homeMultasController.checkPagoMoroso)
      homeMultasScope.$apply()
      homeMultasScope.homeMultasController.validarPago()
      $UTIL.loader.hide()
    }
  },
  iniciarAp () {
    $UTIL.loader.show()
    let homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
    if (homeMultasScope == null) {
      window.open('#/inicio-home', '_self')
      homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
      setTimeout(function () {
        seleccionAllAp()
      }, 4000)
    } else {
      seleccionAllAp()
    }
    function seleccionAllAp () {
      let listMultas = homeMultasScope.homeMultasController.infoMultas.informacionMulta
      checkPagos(listMultas, homeMultasScope.homeMultasController.checkPagoMoroso)
      homeMultasScope.$apply()
      homeMultasScope.homeMultasController.validarAp()
      $UTIL.loader.hide()
    }
  },
  verVehiculoInmovilizado (args) {
    window.open('#/inicio-home', '_self')
    angular.element(document.getElementById('homeVehiculoController'))
      .scope().homeVehiculoController.validarEntregaVeh(args.placa)
  },
  consultarFotodeteccion (arg) {
    angular.element(document.getElementById('busqueda')).scope().ctrl.input = arg.inputText
    document.getElementById('btnBuscar').click()
  },
  /* eslint-enable no-undef */
  citas
}

/* eslint-enable no-unused-vars */



// WEBPACK FOOTER //
// ./src/servicios_digitales_costa/siteActions.js